import { render, staticRenderFns } from "./EventItemView.vue?vue&type=template&id=33045e06"
import script from "./EventItemView.vue?vue&type=script&lang=js"
export * from "./EventItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports